import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';

import theme from './theme';
import SiteHeader from './components/layout/SiteHeader';
import SiteFooter from './components/layout/SiteFooter';
import LandingPage from './pages/LandingPage';
import { LocaleProvider } from './lib/i18n';

/**
 * Vaqtly Holding is a single landing page, so there is no router: one page means
 * no route table to keep in sync, and the in-page anchors do the navigating.
 */
function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocaleProvider>
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <SiteHeader />
          <Box component="main" sx={{ flexGrow: 1 }}>
            <LandingPage />
          </Box>
          <SiteFooter />
        </Box>
      </LocaleProvider>
    </ThemeProvider>
  );
}

export default App;
